import { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchStatusChamado, getNomeStatus } from '../api/statusChamado';

export function useStatusChamado() {
  const location = useLocation();
  const isSolicitante = (location.pathname || '').startsWith('/Solicitante');
  const [statusList, setStatusList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const list = await fetchStatusChamado(isSolicitante);
      setStatusList(list);
    } catch (e) {
      setError(e?.message || 'Erro ao carregar status');
      setStatusList([]);
    } finally {
      setLoading(false);
    }
  }, [isSolicitante]);

  useEffect(() => {
    load();
  }, [load]);

  const getNome = useCallback((statusVal) => getNomeStatus(statusList, statusVal), [statusList]);

  const statusParaSelect = statusList;

  return { statusList, statusParaSelect, loading, error, getNome, refetch: load };
}
